import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Constants,
  LocalStoragerService,
  SessionStoragerService,
} from '../../_utility';
import {GenericConfirmationComponent} from "../../_components/generic-confirmation/generic-confirmation.component";
import {DialogService} from "primeng/dynamicdialog";

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent {
  value: string | undefined;

  wrongInput: boolean = false;

  username!: string | undefined;
  true_username: string | null | undefined;
  password: string | undefined;

  form: FormGroup;

  ships = Constants.SHIPS;
  shipId: string | undefined;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private auth: AuthService,
    private spinner: SpinnerService,
    private lstore: LocalStoragerService,
    private sStore: SessionStoragerService,
    private dialog: DialogService
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.maxLength(10)]],
      shipId: ['', [Validators.required]],
    });
    this.route.queryParams.subscribe((param) => {
      if (param) {
        this.shipId = param['shipId'];
      }
    });
  }

  SingIn() {
    if (!this.form.valid) {
      return;
    }

    this.spinner.show();
    return this.auth.SignIn(this.form.value).subscribe({
      next: (res) => {
        this.sStore.clearAll();
        this.spinner.hide();
        this.auth.setUserInfo(res.auth);
        this.sStore.setElement(Constants.Storager.AUTOLOGIN, false);
        this.lstore.setElement(
          Constants.Storager.SHIPID,
          this.form.value.shipId
        );
        if (res.data) {
          if (res.data.phone) {
            this.sStore.setElement(
              Constants.Storager.PHONE_NUMBER,
              res.data.phone
            );
          }
        }
        this.router.navigate(Constants.Routing.HOME.routerLink);
      },
      error: (err) => {
        this.showError(err?.auth?.error);
        this.form.reset();
        this.spinner.hide();
      },
    });
  }

  private showError(message?: string) {
    if (!message ) message = 'Login Error. Please try again later.';

    this.dialog.open(GenericConfirmationComponent, {
      data: {
        message: message,
      },
    });

  }
}
